import { type MantineColorScheme } from '@mantine/core'

import { ACCOUNT_LOGO_CONFIG } from './constants'
import { type AccountWithLogo } from './types'

export const getAccountLogoSrc = (account: string, colorScheme: MantineColorScheme) => {
  if (!account) {
    return null
  }

  return colorScheme === 'light'
    ? `/assets/images/logos/${account}-light.svg`
    : `/assets/images/logos/${account}-dark.svg`
}

export const hasAccountLogo = (account?: string): account is AccountWithLogo =>
  !!account && Object.hasOwn(ACCOUNT_LOGO_CONFIG, account)
